module.exports = "<oly-button button-class=\"backButton-container\">\r\n    <a class=\"backButton-link backButton\" href=\"javascript://\" ng-click=\"onClick($event)\">\r\n        <i class=\"icon-chevron_back backButton-icon\"></i> Back\r\n    </a>\r\n</oly-button>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/button/back-button-template.html
 ** module id = 845
 ** module chunks = 2
 **/